import React from 'react';

export default function Loader({ isWhite = false }: any) {
  return <span className={`loader ${isWhite ? 'loader--white' : ''}`}></span>;
}
